import React, { useEffect, useId, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom'; // Importa useParams

import { useGetByIdWorkshopsMutation, useUpdateWorkshopsMutation } from '../../../store/api/endpoints/workhopsApiSlice';

import { openFeedback } from '../../../store/slices/feedback';

import HeaderVista from '../../elementos/HeaderVista';
import Input from '../../elementos/Input';
import CropImageNew from '../../elementos/CropImageNew'; // Tu componente de crop
import Loading from '../../elementos/Loading';

import Button from '@mui/material/Button';
import { Breadcrumbs, Divider, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2'; // Importación correcta de Grid

import EventIcon from '@mui/icons-material/Event';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import CheckIcon from '@mui/icons-material/Check';
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';
import NotesIcon from '@mui/icons-material/Notes';
import VideoUploader from '../../elementos/VideoUploader'; // Tu componente de subida de video
import WorkshopsPrevisualizar from './WorkshopsPrevisualizar';

export default function WorkshopsEditar() {
    const { idWorkshop } = useParams(); // Obtiene el ID del workshop desde la URL
    const navigate = useNavigate();
    const dispatch = useDispatch();

    // ID para asociar el video al objectId que no existe aún
    const idObjeto = useId();

    const [isLoadingGetRegistro, setIsLoadingGetRegistro] = useState(true);

    // Estados del formulario
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [speaker, setSpeaker] = useState('');
    const [publicationDate, setPublicationDate] = useState('');

    // Estados para los objetos File (si se seleccionan nuevos)
    const [videoFile, setVideoFile] = useState(null);
    const [previewImageFile, setPreviewImageFile] = useState(null);

    // Estados para las URLs iniciales de video e imagen (obtenidas de la DB)
    const [initialVideoUrl, setInitialVideoUrl] = useState('');
    const [initialPreviewImageUrl, setInitialPreviewImageUrl] = useState('');

    // Estado para la URL que realmente se usará en el <video> (puede ser Blob URL o URL HTTP)
    const [currentVideoSrc, setCurrentVideoSrc] = useState('');

    const [
        getRegistro,
        {
            data: workshopData,
            isLoading: isLoadingWorkshop,
            isSuccess: isSuccessWorkshop,
            isError: isErrorWorkshop,
            error: errorWorkshop
        }
    ] = useGetByIdWorkshopsMutation()


    const [
        putRegistro,
        {
            data: responsePutRegistro,
            isLoading: isLoadingPutRegistro,
            isSuccess: isSuccessPutRegistro,
            isError: isErrorPutRegistro,
            error: errorDataPutRegistro,
        }
    ] = useUpdateWorkshopsMutation();

    useEffect(() => {
        getRegistro({ id: idWorkshop })
    }, [])

    useEffect(() => {
        if (isSuccessWorkshop && workshopData) {
            setTitle(workshopData.data.title || '');
            setDescription(workshopData.data.description || '');
            setSpeaker(workshopData.data.speaker || '');
            // Formatear la fecha para el input type="date" (YYYY-MM-DD)
            if (workshopData.data.publicationDate) {
                const date = new Date(workshopData.data.publicationDate);
                setPublicationDate(date.toISOString().split('T')[0]);
            } else {
                setPublicationDate('');
            }
            // Almacena las URLs originales
            setInitialVideoUrl(workshopData.data.video || '');
            setInitialPreviewImageUrl(workshopData.data.previewImage || '');
            setCurrentVideoSrc(workshopData.data.video || '');

            setIsLoadingGetRegistro(false)
        }
        if (isErrorWorkshop) {
            dispatch(openFeedback({
                severity: 'error',
                message: errorWorkshop.data?.message || "Error al cargar el workshop."
            }));
            navigate("/workshops"); // Redirige si hay error al cargar
        }
    }, [isSuccessWorkshop, workshopData, isErrorWorkshop, errorWorkshop, dispatch, navigate]);


    // Función callback para cuando el VideoUploader devuelve un archivo
    const handleVideoSelected = (file) => {
        setVideoFile(file);
        // Si se selecciona un nuevo archivo, limpia la URL inicial para no mostrar el viejo
        setInitialVideoUrl('');
        console.log("Video seleccionado:", file ? file.name : "ninguno");
    };

    // Función callback para cuando el ImageCropper devuelve un archivo
    const handlePreviewImageCropped = (file) => {
        setPreviewImageFile(file);
        // Si se selecciona un nuevo archivo, limpia la URL inicial para no mostrar el viejo
        setInitialPreviewImageUrl('');
        console.log("Imagen croppeada y lista:", file ? file.name : "ninguna");
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // 1. Crear un objeto FormData
        const formData = new FormData();

        // 2. Adjuntar los campos de texto
        formData.append('title', title);
        formData.append('description', description);
        formData.append('speaker', speaker);
        formData.append('videoId', idObjeto);
        formData.append('publicationDate', publicationDate);


        if (previewImageFile) {
            formData.append('previewImage', previewImageFile);
        } else {
            if (initialPreviewImageUrl) {
                formData.append('previewImage', initialPreviewImageUrl);
            } else {
                dispatch(openFeedback({
                    severity: 'error',
                    message: 'La imagen de vista previa es un campo requerido.'
                }));
                return;
            }
        }

        // 4. Llamar a la mutación de actualización con el ID y el FormData
        putRegistro({ id: idWorkshop, formData });
    };

    // Manejo de feedback para la mutación de actualización
    useEffect(() => {
        if (isErrorPutRegistro) {
            dispatch(openFeedback({
                severity: 'error',
                message: errorDataPutRegistro.data?.message || "Ocurrió un error al actualizar el workshop."
            }));
        }
    }, [isErrorPutRegistro, errorDataPutRegistro, dispatch]);

    useEffect(() => {
        if (isSuccessPutRegistro) {
            dispatch(openFeedback({
                severity: 'success',
                message: "¡Workshop actualizado!"
            }));
            navigate("/workshops");
        }
    }, [isSuccessPutRegistro, dispatch, navigate]);

    // Mostrar loading si se están cargando los datos iniciales o se está actualizando
    if (isLoadingGetRegistro || isLoadingWorkshop || isLoadingPutRegistro) return (<Loading />);
    // Mostrar si los datos del workshop no se cargaron correctamente
    if (isErrorWorkshop && !workshopData) return (<Typography color="error">No se pudo cargar el workshop.</Typography>);


    return (
        <>
            <HeaderVista
                titulo={
                    <Breadcrumbs aria-label="breadcrumb">
                        <Link to="/workshops" style={{ textDecoration: 'none', color: 'inherit' }}>
                            <Typography color="text.primary">Workshops</Typography>
                        </Link>
                        <Typography color="text.primary">Editar</Typography>
                    </Breadcrumbs>
                }
                icon={<OndemandVideoIcon />}
            />
            <form onSubmit={handleSubmit}>
                <Grid container rowSpacing={2} columnSpacing={1}>

                    <Grid size={{ xs: 12, md: 4 }}>
                        <Input
                            label="Fecha Publicación"
                            icon={<EventIcon />}
                            value={publicationDate}
                            onChange={setPublicationDate}
                            type="date"
                            required
                        />
                    </Grid>
                    <Grid size={{ xs: 12, md: 4 }}>
                        <Input
                            label="Título"
                            icon={<OndemandVideoIcon />}
                            value={title}
                            onChange={setTitle}
                            type="text"
                            required
                        />
                    </Grid>
                    <Grid size={{ xs: 12, md: 4 }}>
                        <Input
                            label="Speaker"
                            icon={<RecordVoiceOverIcon />}
                            value={speaker}
                            onChange={setSpeaker}
                            type="text"
                            required
                        />
                    </Grid>
                    <Grid size={{ xs: 12 }}>
                        <Input
                            label="Descripción"
                            icon={<NotesIcon />}
                            value={description}
                            onChange={setDescription}
                            type="text"
                            multiline
                            required
                        />
                    </Grid>
                    <Grid size={{ xs: 12, md: 1 }} align="center"> </Grid>
                    <Grid size={{ xs: 12, md: 4 }} align="center">
                        <CropImageNew
                            imagen={initialPreviewImageUrl} // Pasa la URL actual
                            onImageCropped={handlePreviewImageCropped}
                            maxSizeMB={1}
                            width={500}
                            height={300}
                            avatar={false}
                        />
                        {previewImageFile && (
                            <Typography variant="caption" display="block" sx={{ mt: 1 }}>
                                Nuevo archivo de imagen seleccionado: <strong>{previewImageFile.name}</strong>
                            </Typography>
                        )}
                        {!previewImageFile && initialPreviewImageUrl && (
                            <Typography variant="caption" display="block" sx={{ mt: 1 }}>
                                Imagen actual: <a href={initialPreviewImageUrl} target="_blank" rel="noopener noreferrer">{initialPreviewImageUrl.split('/').pop()}</a>
                            </Typography>
                        )}
                    </Grid>
                    <Grid size={{ xs: 12, md: 1 }} align="center"> </Grid>
                    <Grid size={{ xs: 12, md: 5 }} align="center">
                        {/* Previsualización del video */}
                        <div style={{ marginTop: '16px', marginBottom: '16px', border: '1px solid #e0e0e0', borderRadius: '8px', overflow: 'hidden' }}>
                            {currentVideoSrc ? (
                                <WorkshopsPrevisualizar
                                    url={currentVideoSrc}
                                />
                            ) : (
                                <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', p: 2 }}>
                                    No hay video para previsualizar. Selecciona uno.
                                </Typography>
                            )}
                        </div>
                        <VideoUploader
                            onVideoSelected={handleVideoSelected} // Nuevo callback
                            idObjeto={idObjeto}
                            buttonText="Seleccionar Archivo de Video"
                        />
                        {videoFile && (
                            <Typography variant="caption" display="block" sx={{ mt: 1 }}>
                                Archivo de video seleccionado: <strong>{videoFile.name}</strong>
                            </Typography>
                        )}
                    </Grid>
                    <Grid size={{ xs: 12 }}>
                        <Divider sx={{ my: 3 }} />
                    </Grid>
                    <Grid size={{ xs: 12 }}>
                        <Button type="submit" variant="contained" color="success" startIcon={<CheckIcon />} disabled={isLoadingPutRegistro}>
                            Guardar
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </>
    );
}
